// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1qtps","tab":"ProcedureTabs_tab__3Zvp1"};